import { captureMessage } from "@sentry/gatsby";
import type { UnavailableReason } from "./types";

const reportedUnavailable = new Set<string>();

export const reportUnavailable = (
  key: string,
  reason: UnavailableReason,
  error?: unknown,
) => {
  const dedupeKey = `${key}:${reason}`;
  if (reportedUnavailable.has(dedupeKey)) return;
  reportedUnavailable.add(dedupeKey);

  captureMessage(`Remote config unavailable. ${key}: ${reason}`, {
    level: "warning",
    fingerprint: ["remote-config-unavailable", key, reason],
    tags: { config_key: key, reason },
    extra: {
      errorMessage:
        error instanceof Error
          ? error.message
          : error
            ? String(error)
            : undefined,
    },
  });
};
